module.exports = __webpack_public_path__ + "static/media/carl746-051.c4b445ce.jpg";